exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-box {\n  width: 20rem; }\n\ninput {\n  width: 12rem;\n  padding: 0rem 0.75rem 0rem 0.75rem;\n  font-family: \"browallia\", FontAwesome;\n  text-transform: uppercase; }\n\nselect {\n  width: 12rem; }\n\n.row {\n  margin: 0.4rem 0 0.4rem 0; }\n\n.unset-width {\n  width: unset; }\n\n.textPlease {\n  color: #fbb034;\n  font-weight: bold; }\n\n.select-width {\n  width: 12rem;\n  margin-left: 4rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/input/input.component.scss
// module id = ../../../../../src/app/crm/input/input.component.scss
// module chunks = main